module.exports = __webpack_public_path__ + "img/total-coach-icon.ef86b250.png";